






































import Vue from 'vue'
import { IQuiz } from '../../interfaces/question'
export default Vue.extend({
	name: 'Result',
	components: {},
	props: ['quiz', 'rawAnswer', 'title'],
	data() {
		return {
			answer: {} as any,
			score: 0,
			perfect: 0,
			share: '',
			count: 1,
			imageTank: [''] as any,
			notBot: false,
			image: '',
		}
	},
	mounted: async function () {
		if (!this.rawAnswer) {
			const encoded = getSearchObj(location.search).hash
			const decoded = decodeURIComponent(atob(decodeURIComponent(encoded)))
			this.answer = JSON.parse(decoded)
		} else {
			this.answer = this.rawAnswer
			this.notBot = true
			this.answer = this.rawAnswer
			const encoded = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(this.rawAnswer))))
			const r = location.pathname.match(/\/q\/(.+)$/)
			if (r) {
				const id = r[r.length - 1]
				/*
				fetch(`https://2uwcmuu0id.execute-api.ap-northeast-1.amazonaws.com/default/kukai-ss?id=${id}&hash=${encoded}`)
					.then((response) => response.text())
					.then((data) => {
						this.image = data
						alert('画像が準備できましたから、これを保存してシェアしてください。')
						scrollTo(0, 0)
					})
				alert('ただいま画像を生成中です。30秒程度かかりますが、これが終わるまでOKを押してしばらくお待ちください。')
				*/
			}
		}
		for (const qr of this.quiz) {
			const q = qr as IQuiz
			this.perfect = this.perfect + q.point
			this.score = this.score + ( q.point * this.isCorrect(q.correctAnswer, q.correctAnswerIncline, q.uniqueId))
		}
	},
	methods: {
		isCorrect: function (correctAnswer: string | string[], caInc: number[] | undefined, uniqueId: string) {
			if (typeof correctAnswer === 'string') {
				if (correctAnswer === this.answer[uniqueId]) return 1
				return 0
			} else {
				let i = 0
				for (const a of correctAnswer) {
					if (a === this.answer[uniqueId]) {
						if (!caInc) return 1
						if (caInc[i]) return caInc[i] / 100
					}
					i++
				}
				return 0
			}
		},
		tsCheck: function (answer: string | string[], point?: number[]) {
			if (typeof answer === 'string') {
				return answer
			} else if(point) {
				let b = ''
				let i = 0
				for(const a of answer) {
					b = b ? `${b}, ${a}(${point[i]}%)` : `${a}(${point[i]}%)`
					i++
				}
				return b
			} else {
				return answer.join(',')

			}
		},
		load: function (src: string) {
			return new Promise((resolve, reject) => {
				const img = new Image()
				img.onload = () => resolve(img)
				img.onerror = (e) => reject(e)
				img.src = src
			})
		},
	},
})
function getSearchObj(searchStr: string): { [key: string]: string } {
	if (!searchStr) return {}
	return searchStr
		.substr(1)
		.split('&')
		.reduce((acc, cur) => {
			acc[cur.split('=')[0]] = cur.split('=')[1]
			return acc
		}, {} as { [key: string]: string })
}
